import {
  ITableProp,
  TableColumnsProp,
} from 'src/app/shared/models/tables.model';
import {
  AccordionTabs,
  BulkDeleteItemNames,
  GridColumnsStorageNames,
  MessageTemplates,
  gridMessages,
  popupButtons,
  searchDataParam,
  validationErrorMessages,
} from 'src/app/shared/utility/constants';
import { DataTableConfig } from 'src/app/shared/components/data-table';
import { AccountSummaryRow } from './accounts.model';
import {
  ButtonsConfig,
  ComponentMapping,
  FormConfig,
} from 'src/app/shared/models/dynamic.model';
import { BusinessInformationComponent } from './accounts-information/business-information/business-information.component';
import { GovernmentInformationComponent } from './accounts-information/government-information/government-information.component';
import { AddressComponent } from './accounts-information/address/address.component';
import {
  IAccountsDetailData,
  IAccountsInformationData,
  IAddressInfoDetailsData,
  IBusinessInfoDetailsData,
  ICustomerManagementDetailsData,
  ICustomerService,
  IGovernmentInfoDetailsData,
} from '../../model/sm-accounts';
import { CustomerManagementComponent } from './accounts-information/customer-management/customer-management.component';
import { UsersComponent } from './accounts-information/users/users.component';
import { ValidatorPattern } from '../../../shared/utility/validators.pattern';
import { MasterShipmentBillingCardModel } from '../../model/account.model';
import { RoutingComponent } from './accounts-information/routing/routing.component';

export const accountsAddressTab = ['address', 'billingAddress'];

export const defautAccountPagination = {
  sortingOrder: searchDataParam.desc,
  sortingField: searchDataParam.accountId,
  fromIndex: 0,
  toIndex: 10,
};

export const accountSummaryGridColumns: TableColumnsProp[] = [
  {
    key: 'accountNumber',
    label: 'Account Number',
    isSelected: true,
    defaultView: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'accountName',
    label: 'Account Name',
    isSelected: true,
    defaultView: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'organizationName',
    label: 'Organization Name',
    isSelected: true,
    defaultView: true,
    defaultPrintWidth: 150,
  },
  {
    key: 'shipments',
    label: 'Shipment Count',
    isSelected: true,
    defaultView: true,
    defaultPrintWidth: 130,
  },
  {
    key: 'additionalInfo',
    label: 'Additional Information',
    isSelected: true,
    defaultView: true,
    defaultPrintWidth: 175,
  },
];

export const accountsDataTableConfig: DataTableConfig<AccountSummaryRow> = {
  rowIdField: 'accountId',
  entityName: BulkDeleteItemNames.Accounts,
  storageKey: GridColumnsStorageNames.account,
  features: {
    selection: true,
    pagination: true,
    sorting: true,
    columnReorder: true,
    selectAllAcrossPages: true,
    columnCustomization: true,
  },
  messages: {
    noSearch: gridMessages.accountNoSearch,
    noMatch: gridMessages.noRecordsMatch(BulkDeleteItemNames.Accounts),
    allPageSelected: MessageTemplates.AllItemsSelected,
    selectAll: MessageTemplates.SelectAllItems,
  },
  defaultPagination: {
    pageSize: 10,
    sortField: 'accountId',
    sortDirection: 'desc',
  },
  columns: [
    {
      key: 'accountNumber',
      label: 'Account Number',
      isSelected: true,
      defaultView: true,
      sortable: true,
      isHyperlink: true,
      defaultPrintWidth: 150,
    },
    {
      key: 'accountName',
      label: 'Account Name',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 150,
      showTooltip: true,
    },
    {
      key: 'organizationName',
      label: 'Organization Name',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 150,
      showTooltip: true,
    },
    {
      key: 'shipments',
      label: 'Shipment Count',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 130,
    },
    {
      key: 'additionalInfo',
      label: 'Additional Information',
      isSelected: true,
      defaultView: true,
      sortable: true,
      defaultPrintWidth: 175,
      showTooltip: true,
    },
  ],
};

export const AccountInfoCrudFormConfig: FormConfig = {
  fields: [
    {
      id: 'accountName',
      type: 'input',
      label: 'Account Name',
      required: true,
      requiredError: 'Account Name is required',
      allowAlphaNumericWithHyphenAmpersandParenthesesSpace: true,
      minValue: 2,
      maxValue: 126,
      minError: 'Invalid Account Name entered',
    },
    {
      id: 'accountNumber',
      type: 'input',
      label: 'Account Number',
      required: true,
      requiredError: 'Account Number is required',
      allowNumberWithFirstNonZeroNumber: true,
      minValue: 7,
      maxValue: 7,
      minError: 'Account Number must be 7 digits',
    },
    {
      id: 'organizationName',
      type: 'select',
      label: 'Organization Name',
      required: true,
      requiredError: 'Organization Name is required',
    },
    {
      id: 'serviceable',
      type: 'select',
      label: 'Serviceable',
    },
    {
      id: 'measurementOptions',
      type: 'select',
      label: 'Measurement Options',
    },
    {
      id: 'timeZone',
      type: 'select',
      label: 'Time Zone',
    },
    {
      id: 'timeZoneId',
      type: 'extra',
    },
    {
      id: 'description',
      type: 'input',
      label: 'Description',
      noInitialWhiteSpace: true,
      allowAlphaNumericWithSpace: true,
      maxValue: 126,
      isCheckForMaxValue: true,
    },
    {
      id: 'additionalInformation',
      type: 'input',
      label: 'Additonal Information',
      noInitialWhiteSpace: true,
      allowAlphaNumericWithSpace: true,
      maxValue: 500,
      isCheckForMaxValue: true,
    },
    {
      id: 'accountId',
      type: 'extra',
    },
    {
      id: 'organizationId',
      type: 'extra',
    },
    {
      type: 'extra',
      id: 'isAccountHasDependancy',
    },
  ],
};

export const accountsAccordionTabConfig: ComponentMapping[] = [
  {
    title: AccordionTabs.Address,
    componentType: AddressComponent,
  },
  {
    title: AccordionTabs.BusinessInformation,
    componentType: BusinessInformationComponent,
  },
  {
    title: AccordionTabs.GovernmentInformation,
    componentType: GovernmentInformationComponent,
  },
  {
    title: AccordionTabs.CustomerManagement,
    componentType: CustomerManagementComponent,
  },
  { title: AccordionTabs.Attachments, componentType: '' },
  { title: AccordionTabs.Events, componentType: '' },
  { title: AccordionTabs.Users, componentType: UsersComponent },
  { title: AccordionTabs.routing, componentType: RoutingComponent },
  { title: AccordionTabs.Details, componentType: '' },
];

export const organizationCrudFormConfig: FormConfig = {
  fields: [
    {
      id: 'organizationName',
      type: 'input',
      label: 'Organization Name',
      required: true,
      requiredError: 'Organization Name is required',
      noInitialWhiteSpace: true,
      allowAlphabetWithSpace: true,
      minValue: 2,
      maxValue: 126,
      minError:
        'Organization Name should be only alphabets and more than 2 characters and unique and required',
    },
    {
      id: 'description',
      type: 'input',
      label: 'Description',
    },
    {
      id: 'additionalInfo',
      type: 'input',
      label: 'Additional Information',
    },
  ],
};

export const commonBtnForModalFooter = [
  {
    name: 'Cancel',
    btnClass: 'ibc-medium-button ibc-secondary-default-button cursor',
  },
];

export const buttonsForAccountsAlreadyExistModal: ButtonsConfig[] = [
  ...commonBtnForModalFooter,
  {
    name: 'Try Another',
    btnClass: 'ibc-medium-button ibc-secondary-default-button cursor',
  },
  {
    name: 'Create Linked Account',
    btnClass: 'ibc-secondary-accent-button-md cursor',
  },
  {
    name: 'Use Suggested Account',
    btnClass: 'ibc-medium-button ibc-primary-default-button cursor',
  },
];

export const buttonsForSendCredentials: ButtonsConfig[] = [
  ...commonBtnForModalFooter,
  {
    name: 'Send Credentials',
    btnClass: 'ibc-medium-button ibc-primary-default-button cursor',
  },
];

export const buttonsForFirstLinkedAccount: ButtonsConfig[] = [
  ...commonBtnForModalFooter,
  {
    name: 'Proceed',
    btnClass: 'ibc-medium-button ibc-primary-default-button cursor',
  },
];

export const businessInformationFormFields: FormConfig = {
  fields: [
    {
      id: 'DUNSNumber',
      type: 'input',
      label: 'DUNS Number',
      noInitialWhiteSpace: true,
      allowNumeric: true,
      minValue: 9,
      maxValue: 9,
      minError: 'Invalid DUNS Number entered',
    },
    {
      id: 'FEINNumber',
      type: 'input',
      label: 'FEIN Number',
      noInitialWhiteSpace: true,
      minValue: 9,
      maxValue: 11,
      minError: 'Invalid FEIN Number entered',
      isCheckForMaxValue: true,
    },
    {
      id: 'stateTaxId',
      type: 'input',
      label: 'State Tax ID',
      noInitialWhiteSpace: true,
      minValue: 9,
      maxValue: 12,
      minError: 'Invalid State Tax ID entered',
      isCheckForMaxValue: true,
    },
    {
      id: 'paymentTerms',
      type: 'select',
      label: 'Payment Terms (days)',
      minValue: 0,
      maxValue: 1000,
      isCheckForMaxValue: true,
      allowPaymentTermsInput: true,
      required: true,
      requiredError: 'Payment Terms is mandatory',
    },
    {
      id: 'creditLimit',
      type: 'input',
      label: 'Credit Limit',
      allowAlphaNumericWithSpaceNoSpecialCharacter: true,
      maxValue: 126,
    },
  ],
};

export const governmentInformationFields: FormConfig = {
  fields: [
    {
      id: 'isAutoRate',
      type: 'select',
      label: 'Auto-rate',
    },
    {
      id: 'salesPerson',
      type: 'select',
      label: 'Sales Person',
    },
    {
      id: 'salesPersonId',
      type: 'extra',
      label: 'Sales Person',
    },
    {
      id: 'invoiceFileFormat',
      type: 'select',
      label: 'Invoice File Format',
      required: true,
      requiredError: 'Invoice File Format is required',
    },
    {
      id: 'billingType',
      type: 'select',
      label: 'Billing Type',
      required: true,
      requiredError: 'Billing Type is required',
    },
    {
      id: 'selectEmailsForInvoiceNotification',
      type: 'multi-select-autocomplete',
      label: 'Select Emails for Invoice Notification',
    },
    {
      id: 'selectEmailsforGatewayNotification',
      type: 'multi-select-autocomplete',
      label: 'Select Emails for Gateway Notification',
    },
    {
      id: 'serviceTypes',
      type: 'select',
      label: 'Service Type',
    },
    {
      id: 'deliveryAgentId',
      type: 'select',
      label: 'Delivery Agent',
    },
    {
      id: 'invoiceType',
      type: 'select',
      label: 'Invoice Type',
    },
  ],
};

/** Auto-rate (account level) options; blank / null is treated as Yes. */
export const AUTO_RATE_OPTIONS: Array<{ id: boolean; name: string }> = [
  { id: true, name: popupButtons.Yes },
  { id: false, name: popupButtons.No },
];

export const customerMaagementFields: FormConfig = {
  fields: [
    {
      id: 'clearanceType',
      type: 'select',
      label: 'Clearance Type',
    },
    {
      id: 'clearanceChannel',
      type: 'select',
      label: 'Clearance Channel',
    },
    {
      id: 'scanPreferenceId',
      type: 'select',
      label: 'Scan Preference',
    },
    {
      id: 'scanPreference',
      type: 'select',
      label: 'Scan Preference',
      required: true,
      requiredError: 'Scan Preference is required',
    },
    {
      id: 'deliveryTerms',
      type: 'select',
      label: 'Default Delivery Terms',
    },
    {
      id: 'customTranslation',
      type: 'toggle',
      label: 'Custom Translation',
    },
    {
      id: 'needsClearanceNonUsDelivery',
      type: 'toggle',
      label: 'Needs clearance for Non US delivery shipments landing in US',
    },
    {
      id: 'noNeedClearance',
      type: 'toggle',
      label: 'No Need Clearance',
    },
  ],
};

export const customerServiceTableColumnConfig: TableColumnsProp[] = [
  {
    key: 'rateScale',
    label: 'Rate Scale',
    isSelected: true,
    defaultPrintWidth: 100,
  },
  {
    key: 'markUp',
    label: 'Mark Up(%)',
    isSelected: true,
    defaultPrintWidth: 100,
  },
];

export const customerServiceFormConfig: FormConfig = {
  fields: [
    {
      id: 'rateScale',
      type: 'select',
      label: 'Rate Scale',
      required: true,
      requiredError: 'Rate Scale is required',
    },
    {
      id: 'rateScaleId',
      type: 'extra',
    },
    {
      id: 'markUp',
      type: 'input',
      label: 'Mark Up (%)',
    },
    {
      id: 'id',
      type: 'extra',
    },
    {
      id: 'tempId',
      type: 'extra',
    },
    {
      id: 'isRowDisable',
      type: 'extra',
    },
    {
      id: 'action',
      type: 'extra',
    },
  ],
};

export const accountUsersTableColumnConfig: TableColumnsProp[] = [
  {
    key: 'fullName',
    label: 'Full Name',
    isSelected: true,
    defaultPrintWidth: 100,
  },
  {
    key: 'email',
    label: 'Email Address',
    isSelected: true,
    defaultPrintWidth: 100,
  },
];

export const accountUserServiceFormConfig: FormConfig = {
  fields: [
    {
      id: 'fullName',
      type: 'input',
      label: 'Full Name',
      required: true,
      requiredError: 'Full Name is required',
      noInitialWhiteSpace: true,
      maxValue: 126,
    },
    {
      id: 'email',
      type: 'input',
      label: 'email',
      required: true,
      pattern: ValidatorPattern.Email_Validator,
      emailPatternError: validationErrorMessages.invalidEmailEntered,
      noInitialWhiteSpace: true,
      requiredError: 'Valid Email is required',
      maxValue: 50,
      isCheckForMaxValue: true,
    },
    {
      id: 'id',
      type: 'extra',
    },
    {
      id: 'isRowDisable',
      type: 'extra',
    },
    {
      id: 'tempId',
      type: 'extra',
    },
  ],
};

export const firstLinkedAccountRadioOptions: string[] = [
  'Change Existing Shipments to Account 1234501',
  'Leave Existing Shipments as Account 1234500',
];

export const defaultAccountsDetailData = (): IAccountsDetailData => ({
  accountName: '',
  accountNumber: 0,
  organizationName: '',
  organizationId: 0,
  description: '',
  additionalInformation: '',
  accountId: 0,
  isAccountHasDependancy: false,
  measurementOptions: '',
  timeZone: '',
  timeZoneId: 0,
});

export const defaultAccountsAddressInfoData = (): IAddressInfoDetailsData => ({
  address: defaultAccountsAddressData,
  billingAddress: defaultAccountsAddressData,
  isSameAsAdress: false,
});

export const defaultAccountsAddressData = {
  country: '',
  phone: '',
  email: '',
  name: '',
  companyName: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  postalCode: '',
  contactPerson: '',
};

export const defaultAccountsBusinessInfoData =
  (): IBusinessInfoDetailsData => ({
    DUNSNumber: '',
    FEINNumber: '',
    stateTaxId: '',
    paymentTerms: '',
    creditLimit: '',
  });

export const defaultCustomerManagementData =
  (): ICustomerManagementDetailsData => ({
    clearanceType: [],
    clearanceTypeData: [],
    clearanceChannel: [],
    clearanceChannelData: [],
    customTranslation: false,
    needsClearanceNonUsDelivery: false,
    noNeedClearance: false,
    scanPreference: '',
    scanPreferenceId: 0,
    deliveryTerms: [],
  });

export const defaultAccountsGovernmentInfoData =
  (): IGovernmentInfoDetailsData => ({
    salesPerson: '',
    salesPersonId: 0,
    selectEmailsForInvoiceNotification: [],
    selectEmailsforGatewayNotification: [],
    serviceTypes: getGovernmentServiceTypesTbdValue(),
    deliveryAgentId: '',
    customerService: defaultCustomerServiceData,
    billingType: [2],
    invoiceFileFormat: 10,
    invoiceType: null,
    isAutoRate: true,
    isAccountHasARInvoice: false,
    masterShipmentBilling: {
      recoveryAmount: '',
      recoveryWeightMetric: 0,
      recoveryIbcChargeCode: 0,
      deliveryAmount: '',
      deliveryWeightMetric: 0,
      deliveryIbcChargeCode: 0,
      reimbursableChargesClearanceType: '',
      reimbursableChargesValuePerShipment: '',
      reimbursableChargesIbcChargeCode: 0,
      clearanceChargesClearanceType: '',
      clearanceChargesValuePerShipment: '',
      clearanceChargesIbcChargeCode: 0,
      iscActualCost: '',
      iscFlatFee: '',
      iscIbcChargeCode: 0,
    },
  });

/** Hardcoded UI placeholder when Service Type / Delivery Agent are unset (not a master lookup value). */
export const GOVERNMENT_INFO_TBD_DISPLAY = 'TBD';

/** Agent code preselected as Delivery Agent when configuring a new account. */
export const IBC_DEFAULT_AGENT_CODE = 'IBCDEFAULTAGENT';

export function isGovernmentDeliveryAgentTbd(
  deliveryAgentId: number | string | null | undefined
): boolean {
  if (deliveryAgentId == null || deliveryAgentId === '') {
    return true;
  }
  if (typeof deliveryAgentId === 'number') {
    return deliveryAgentId === 0;
  }
  return ['0', GOVERNMENT_INFO_TBD_DISPLAY].includes(
    String(deliveryAgentId).trim()
  );
}

export function isGovernmentServiceTypeTbd(
  serviceTypes: string[] | null | undefined
): boolean {
  if (!serviceTypes?.length) {
    return true;
  }
  return (
    serviceTypes.length === 1 &&
    serviceTypes[0] === GOVERNMENT_INFO_TBD_DISPLAY
  );
}

export function getGovernmentServiceTypesTbdValue(): string[] {
  return [GOVERNMENT_INFO_TBD_DISPLAY];
}

export function getSavedCustomerServiceCount(
  customerService: ICustomerService[] | undefined
): number {
  return (customerService ?? []).filter(row => row.isRowDisable).length;
}

export const defaultCustomerServiceData: ICustomerService[] = [
  {
    id: 0,
    tempId: '',
    action: 'create',
    rateScale: '',
    rateScaleId: '',
    markUp: '',
    isRowDisable: false,
  },
];

export const AccountExcelHeaders: string[] = [
  'Account Number',
  'Account Name',
  'Organization Name',
  'Shipment Count',
  'Additional Info',
];

export const defaultAccountsInformationData = (): IAccountsInformationData => ({
  ...defaultAccountsDetailData(),
  addressData: defaultAccountsAddressInfoData(),
  businessInformation: defaultAccountsBusinessInfoData(),
  customerManagement: defaultCustomerManagementData(),
  governmentInformation: defaultAccountsGovernmentInfoData(),
  attachments: [],
  users: [],
});

export const serviceableDropDownData: any = [
  { id: 1, name: 'Yes', value: true },
  { id: 2, name: 'No', value: false },
];

export const linkedAccountTableColumnConfig: TableColumnsProp[] = [
  {
    key: 'linkedAccount',
    label: 'Accounts',
    isSelected: true,
  },
  {
    key: 'details',
    label: 'Actions',
    isSelected: true,
  }
];

export const AccountInfoSectionHeaderss: string[] = [
  'Account Name',
  'Account Number',
  'Organization Name',
  'Serviceable',
  'Description',
  'Additional Information',
  'Address',
  'Business Information',
  'Government Information',
  'Customer Management',
  'Events',
  'Users',
  'Details',
];

export const AccountInfoSectionHeaderKeyss: string[] = [
  'accountBasicInfo',
  'address',
  'businessInformation',
  'governmentInformation',
  'customerManagement',
  'events',
  'users',
  'details',
];
export const AccountInfoSectionHeaders = {
  accountBasicInfo: 'Account Information',
  address: 'Account Address',
  businessInformation: 'Business Information',
  customerManagement: 'Customer Management',
  details: 'Details',
  events: 'Events',
  users: 'Users',
  governmentInformation: 'Government Information',
};

export const AccountInfoSectionHeaderKeys = {
  accountBasicInfo: 'accountBasicInfo',
  address: 'address',
  businessInformation: 'businessInformation',
  customerManagement: 'customerManagement',
  details: 'details',
  events: 'events',
  users: 'users',
  governmentInformation: 'governmentInformation',
};

export const recoveryFeesFormConfig: FormConfig = {
  fields: [
    {
      id: 'recoveryAmount',
      label: 'Amount ($)',
      type: 'input',
      allowNumericWithDecimal: true,
    },
    {
      type: 'select',
      id: 'recoveryWeightMetric',
      label: 'Weight Metric',
    },
    {
      id: 'recoveryIbcChargeCode',
      type: 'autocomplete',
      label: 'IBC Charge Code',
    },
  ],
};
export const deliveryFeesFormConfig: FormConfig = {
  fields: [
    {
      label: 'Amount ($)',
      id: 'deliveryAmount',
      type: 'input',
      allowNumericWithDecimal: true,
    },
    {
      id: 'deliveryWeightMetric',
      type: 'select',
      label: 'Weight Metric',
    },
    {
      id: 'deliveryIbcChargeCode',
      type: 'autocomplete',
      label: 'IBC Charge Code',
    },
  ],
};

export const reimbursableChargesFormConfig: FormConfig = {
  fields: [
    {
      id: 'reimbursableChargesClearanceType',
      label: 'Clearance Type',
      type: 'autocomplete',
    },
    {
      label: 'Value per Shipment ($)',
      type: 'input',
      id: 'reimbursableChargesValuePerShipment',
      allowNumericWithDecimal: true,
    },
    {
      id: 'reimbursableChargesIbcChargeCode',
      type: 'autocomplete',
      label: 'IBC Charge Code',
    },
  ],
};
export const clearanceChargesFormConfig: FormConfig = {
  fields: [
    {
      id: 'clearanceChargesClearanceType',
      label: 'Clearance Type',
      type: 'autocomplete',
    },
    {
      label: 'Value per Shipment ($)',
      type: 'input',
      id: 'clearanceChargesValuePerShipment',
      allowNumericWithDecimal: true,
    },
    {
      id: 'clearanceChargesIbcChargeCode',
      type: 'autocomplete',
      label: 'IBC Charge Code',
    },
  ],
};

export const iscFormConfig: FormConfig = {
  fields: [
    {
      label: 'Actual Cost',
      type: 'input',
      id: 'iscActualCost',
    },
    {
      type: 'input',
      label: 'Flat Fee',
      id: 'iscFlatFee',
      allowNumericWithDecimal: true,
    },
    {
      id: 'iscIbcChargeCode',
      type: 'autocomplete',
      label: 'IBC Charge Code',
    },
  ],
};

export const masterShipmentBillingList: MasterShipmentBillingCardModel[] = [
  {
    form: recoveryFeesFormConfig.fields,
    header: 'Recovery',
  },
  {
    header: 'Reimbursable Charges',
    form: reimbursableChargesFormConfig.fields,
  },
  {
    form: iscFormConfig.fields,
    header: 'ISC',
  },
  {
    header: 'Delivery Fees',
    form: deliveryFeesFormConfig.fields,
  },
  {
    form: clearanceChargesFormConfig.fields,
    header: 'Clearance Charges',
  },
];

export const defautAccountPayabalePagination = {
  sortingOrder: searchDataParam.desc,
  sortingField: searchDataParam.id,
  fromIndex: 0,
  toIndex: 10,
};

export const downloadExcelHeaders = {
  accountsInfoSecionHeaders: [
    'Account Name',
    'Account Number',
    'Organization Name',
    'Serviceable',
    'Measurement Options',
    'Time Zone',
    'Description',
    'Additional Information',
  ],
  accountAddressSectionHeaders: [
    'Country',
    'Phone',
    'Email',
    'Name',
    'Company Name',
    'Address 1',
    'Address 2',
    'City',
    'State',
    'Zip Code',
  ],
  billingAddressSectionHeaders: [
    'Country',
    'Phone',
    'Email',
    'Name',
    'Company Name',
    'Address 1',
    'Address 2',
    'City',
    'State',
    'Zip Code',
  ],
  governmentInfoSectionHeaders: [
    'Sales Person',
    'Invoice File Format',
    'Billing Type',
    'Delivery Agents',
    'Service Types',
  ],
  masterShipmentBillingSectionHeaders: [
    'Recovery Amount',
    'Recovery Weight Metric',
    'Recovery IBC Charge Code',
    'Delivery Amount',
    'Delivery Weight Metric',
    'Delivery IBC Charge Code',
    'Reimbursable Clearance Type',
    'Reimbursable Value/Shipment',
    'Reimbursable IBC Charge Code',
    'Clearance Clearance Type',
    'Clearance Value/Shipment',
    'Clearance IBC Charge Code',
    'ISC Actual Cost',
    'ISC Flat Fee',
    'ISC IBC Charge Code',
  ],
  customerServiceSectionHeaders: [
    'Mark Up',
    'Rate Scale',
  ],
  businessInfoSectionHeaders: [
    'DUNS Number',
    'FEIN Number',
    'State Tax ID',
    'Payment Terms',
    'Credit Limit',
  ],
  customerManagementSectionHeaders: [
    'Scan Preference',
    'No Need Clearance',
    'Custom Translation',
    'Needs clearance for Non US delivery shipments landing in US',
  ],
  usersSectionHeaders: ['Full Name', 'Username(Email)'],
  detailsSectionHeaders: ['Account ID', 'Organization ID'],
};

export const downloadExcelKeys = {
  accountsInfoSecionKeys: [
    'accountName',
    'accountNumber',
    'organizationName',
    'serviceable',
    'measurementOptions',
    'timeZone',
    'description',
    'additionalInformation',
  ],
  accountAddressSectionKeys: [
    'countryCode',
    'phone',
    'email',
    'name',
    'companyName',
    'address_1',
    'address_2',
    'city',
    'state',
    'zipCode',
  ],
  billingAddressSectionKeys: [
    'countryCode',
    'phone',
    'email',
    'name',
    'companyName',
    'address_1',
    'address_2',
    'city',
    'state',
    'zipCode',
  ],
  governmentInfoSectionKeys: [
    'salesPerson',
    'invoiceFileFormat',
    'billingType',
    'deliveryAgents',
    'serviceTypes',
  ],
  masterShipmentBillingSectionKeys: [
    'recoveryAmount',
    'recoveryWeightMetric',
    'recoveryIbcChargeCode',
    'deliveryAmount',
    'deliveryWeightMetric',
    'deliveryIbcChargeCode',
    'reimbursableChargesClearanceType',
    'reimbursableChargesValuePerShipment',
    'reimbursableChargesIbcChargeCode',
    'clearanceChargesClearanceType',
    'clearanceChargesValuePerShipment',
    'clearanceChargesIbcChargeCode',
    'iscActualCost',
    'iscFlatFee',
    'iscIbcChargeCode',
  ],
  customerServiceSectionKeys: [
    'markUp',
    'rateScale',
  ],
  businessInfoSectionKeys: [
    'DUNSNumber',
    'FEINNumber',
    'stateTaxId',
    'paymentTerms',
    'creditLimit',
  ],
  customerManagementSectionKeys: [
    'scanPreference',
    'noNeedClearance',
    'customTranslation',
    'needsClearanceNonUsDelivery',
  ],
  usersSectionKeys: ['fullName', 'email'],
  detailsSectionKeys: ['accountId', 'organizationId'],
};

export const userDetailsEvent = ['fullName', 'email'];

export interface RoutingCriteriaRow {
  serviceType: string;
  shipmentValueMin: string;
  shipmentValueMax: string;
  shipmentWeightMin: string;
  shipmentWeightMax: string;
  modeOfTransport: string;
  shipmentType: string;
  isInputRow?: boolean;
  serviceTypeId?: string;
  modeOfTransportId?: string;
  modeOfTransportType?: string;
  shipmentTypeId?: string;
}

export const routingCriteriaGridColumns: ITableProp[] = [
  { key: 'serviceType', label: 'Service Type' },
  { key: 'shipmentValue', label: 'Shipment Value (Minimum - Maximum) ($)' },
  { key: 'shipmentWeight', label: 'Shipment Weight (Minimum - Maximum) (lb)' },
  { key: 'modeOfTransport', label: 'Mode of Transport' },
  { key: 'shipmentType', label: 'Shipment Type' },
];

export const routingCriteriaFormConfig: FormConfig = {
  fields: [
    {
      id: 'serviceType',
      type: 'select',
      label: 'Service Type',
      required: true,
      requiredError: 'Service Type is required'
    },
    {
      id: 'shipmentValueMin',
      type: 'input',
      label: 'Minimum',
      allowNumericWithDecimal: true,
      isDecimalField: true,
      pattern: ValidatorPattern.TwoDecimalPlaces,
      patternError: 'Enter a valid number with up to 2 decimal places'
    },
    {
      id: 'shipmentValueMax',
      type: 'input',
      label: 'Maximum',
      allowNumericWithDecimal: true,
      isDecimalField: true,
      pattern: ValidatorPattern.TwoDecimalPlaces,
      patternError: 'Enter a valid number with up to 2 decimal places'
    },
    {
      id: 'shipmentWeightMin',
      type: 'input',
      label: 'Minimum',
      allowNumericWithDecimal: true,
      isDecimalField: true,
      pattern: ValidatorPattern.TwoDecimalPlaces,
      patternError: 'Enter a valid number with up to 2 decimal places'
    },
    {
      id: 'shipmentWeightMax',
      type: 'input',
      label: 'Maximum',
      allowNumericWithDecimal: true,
      isDecimalField: true,
      pattern: ValidatorPattern.TwoDecimalPlaces,
      patternError: 'Enter a valid number with up to 2 decimal places'
    },
    { id: 'modeOfTransport', type: 'select', label: 'Mode of Transport' },
    { id: 'shipmentType', type: 'select', label: 'Shipment Type' },
  ],
};
